// FTEDN Team App — Router (all admin pages)
import { Routes, Route, Navigate } from 'react-router-dom';
import { isStaffRole } from '@ftedn/shared';
import { useAuthStore } from './stores/auth.store';
import { MainLayout } from './components/layout/MainLayout';
import { LoginPage } from './pages/Auth/LoginPage';
import { DashboardPage } from './pages/Dashboard/DashboardPage';
import { WaitlistMgmtPage } from './pages/Waitlist/WaitlistMgmtPage';
import { BetaMgmtPage } from './pages/Beta/BetaMgmtPage';
import { FeedbackIntelPage } from './pages/Feedback/FeedbackIntelPage';
import { VotingMgmtPage } from './pages/Voting/VotingMgmtPage';
import { CommunityModPage } from './pages/Community/CommunityModPage';
import { ShipmentMgmtPage } from './pages/Shipments/ShipmentMgmtPage';
import { CreatorsPage } from './pages/Creators/CreatorsPage';
import { FlagAdminPage } from './pages/Flags/FlagAdminPage';
import { BackupsPage } from './pages/Backups/BackupsPage';
import { SmsPage } from './pages/Sms/SmsPage';
import { EmailPage } from './pages/Email/EmailPage';
import { ProductsPage } from './pages/Products/ProductsPage';
import { ProductDetailPage } from './pages/Products/ProductDetailPage';
import { ModerationPage } from './pages/Moderation/ModerationPage';
import { AnalyticsPage } from './pages/Analytics/AnalyticsPage';
import { AmbassadorPage } from './pages/Ambassador/AmbassadorPage';
import { ChatAdminPage } from './pages/Chat/ChatAdminPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, user } = useAuthStore();
  if (isLoading) return <div className="loading-screen">Loading...</div>;
  if (!isAuthenticated || !user || !isStaffRole(user.role)) return <Navigate to="/login" replace />;
  return <MainLayout>{children}</MainLayout>;
}

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/waitlist" element={<ProtectedRoute><WaitlistMgmtPage /></ProtectedRoute>} />
      <Route path="/creators" element={<ProtectedRoute><CreatorsPage /></ProtectedRoute>} />
      <Route path="/beta" element={<ProtectedRoute><BetaMgmtPage /></ProtectedRoute>} />
      <Route path="/feedback" element={<ProtectedRoute><FeedbackIntelPage /></ProtectedRoute>} />
      <Route path="/voting" element={<ProtectedRoute><VotingMgmtPage /></ProtectedRoute>} />
      <Route path="/community" element={<ProtectedRoute><CommunityModPage /></ProtectedRoute>} />
      <Route path="/shipments" element={<ProtectedRoute><ShipmentMgmtPage /></ProtectedRoute>} />
      <Route path="/flags" element={<ProtectedRoute><FlagAdminPage /></ProtectedRoute>} />
      <Route path="/backups" element={<ProtectedRoute><BackupsPage /></ProtectedRoute>} />
      <Route path="/sms" element={<ProtectedRoute><SmsPage /></ProtectedRoute>} />
      <Route path="/email" element={<ProtectedRoute><EmailPage /></ProtectedRoute>} />
      <Route path="/products" element={<ProtectedRoute><ProductsPage /></ProtectedRoute>} />
      <Route path="/products/:id" element={<ProtectedRoute><ProductDetailPage /></ProtectedRoute>} />
      <Route path="/moderation" element={<ProtectedRoute><ModerationPage /></ProtectedRoute>} />
      <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
      <Route path="/ambassadors" element={<ProtectedRoute><AmbassadorPage /></ProtectedRoute>} />
      <Route path="/chat" element={<ProtectedRoute><ChatAdminPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
